<template>
  <v-container fluid>
    <!-- Explanation -->
    <div class="py-2 px-1">
      <span class="headline font-weight-medium text-uppercase font-italic" style="color:#C7A754">Kendeda
        Building</span>
      <v-img tile contain :src="require('@/assets/kendeda.jpg')">
      </v-img>
    </div>

    <div class="py-2 px-1">
      <span class="h1 font-weight-medium text-uppercase" style="color:#C7A754">Select Year</span>
      <v-btn-toggle class="flex-wrap" v-model="year" mandatory>
        <v-btn v-for="(year, idx) in yearChoices" :key="idx" x-small :value="year"> {{ year }} </v-btn>
      </v-btn-toggle>
    </div>

    <div class="py-2 px-1">
      <div>
        <span class="h1 font-weight-medium text-uppercase" style="color:#C7A754">Select Unit</span>
      </div>
      <div>
        <v-btn-toggle class="flex-wrap" v-model="unit" mandatory>
          <v-btn @click="changeUnit('SI')"> <!-- This was KWH/M2, changed to SI -->
            SI
          </v-btn>
          <v-btn @click="changeUnit('Imperial')"> <!-- This was KBTU/SQFT, changed to Imperial -->
            Imperial
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>

    <div>&nbsp</div>
    <center>
      <h3>Acronyms Used</h3>
    </center>
    <center>
      <p>See definitions at footer</p>
    </center>
    <ul>
      <li>EUI - Energy Usage Intensity</li>
      <li>EUIMA - EUI Moving Average</li>
      <li>BTL - Building Total Load</li>
      <li>ER - Energy Ratio</li>
      <li>ERMA - ER Moving Average</li>
    </ul>
    
    <div class="mt-3 pa-2" style="border: 2px solid #C7A754; border-radius: 4px;">
      <p class="font-weight-bold mb-1" style="color: #C7A754;">IMPORTANT NOTICE:</p>
      <p>Data for 2024 is taken from PME data sources as well as models based on historical trends. This is due to inconsistencies in Skyspark data.</p>
    </div>
  </v-container>
</template>


<script>
import yearOptions from '../../yearOptions.json';

export default {
  emits: ["submit"],
  data: () => ({
    unit: null,
    year: null,
  }),
  methods: {
    changeUnit(input) {
      this.$store.commit("updateKBEUI_unit", input)
    },
    begin() {
      this.$emit("submit", this.year)
    }
  },
  watch: {
    year: function(oldyear, newyear) {
      this.begin();
    }
  },
  computed: {
    yearChoices() {
      return yearOptions;
    }
  }
}
</script>
